import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  name: string
  children: ReactNode
  /** When this value changes (for example the page address), a failed section gets another try. */
  resetKey?: string
  /** What to show instead of a failed section. Defaults to nothing. */
  fallback?: ReactNode
}
interface State { failed: boolean; key?: string }

/** Keeps one broken section from taking the whole page down. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false, key: this.props.resetKey }
  static getDerivedStateFromError(): Partial<State> {
    return { failed: true }
  }
  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    return props.resetKey !== state.key ? { failed: false, key: props.resetKey } : null
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[mauj] The ${this.props.name} section failed to render.`, error, info.componentStack)
  }
  render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children
  }
}
